<template>
  <SideHeader :indexPage="true" />
  <div style="padding-top: 55px;">
    <div id="loader" v-if="loading">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div v-else>
      <div class="bg-white">
        <div style="height:128px">
          <Map v-if="path" :LatLngFirst="[path.fromLatLong.latitude, path.fromLatLong.longitude]"
            :centerValue="[(+path.fromLatLong.latitude + +path.toLatLong.latitude) / 2, (+path.fromLatLong.longitude + +path.toLatLong.longitude) / 2]"
            :latLngSecond="[path.toLatLong.latitude, path.toLatLong.longitude]"
            :latLngs="[[path.fromLatLong.latitude, path.fromLatLong.longitude], [path.toLatLong.latitude, path.toLatLong.longitude]]"
            :distance="cargo.distanceCity" />
          <div class="routing">
            <a href="#" type="button" class="btn background-locate text-locate p-1" data-bs-toggle="offcanvas"
              :data-bs-target="'#actionSheetIconed_' + loadId" @click="offClose()">
              مسیریابی روی نقشه
              <ion-icon role="img" class="md hydrated" style="margin-left: 0;"
                name="chevron-forward-outline"></ion-icon>
            </a>
            <Routing v-if="path" :cargo="loadId" :fromLat="path.fromLatLong.latitude"
              :fromLong="path.fromLatLong.longitude" :toLat="path.toLatLong.latitude"
              :toLong="path.toLatLong.longitude" />
          </div>
        </div>

        <div class="m-2">
          <div class="card-body py-0">
            <WithoutPrice :distanceCity="cargo.distanceCity" :distanct="cargo.distanct" :fromCity="cargo.fromCity"
              :toCity="cargo.toCity" />
          </div>

          <PaymentBox :cargo="cargo" />

          <div class="return-loads-wrapper">
            <div class="return-loads-text">
              <p>
                <router-link class="btn btn-link load-back p-0"
                  :to="{ name: 'returnLoads', params: { city: cargo.destination_city_id } }">
                  مشاهده بارهای مقصد
                  <ion-icon role="img" class="md hydrated" name="chevron-forward-outline"
                    style="font-size:15px; padding-top: 2px;"></ion-icon>
                </router-link>
              </p>
            </div>
          </div>

          <div class="section full mt-1 pb-7">
            <ul class="nav nav-tabs lined border-gray" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" :href="'#cargo' + loadId" role="tab">اطلاعات بار</a>
              </li>
              <li class="nav-item" v-show="owner != null && owner?.isAccepted == 1">
                <a class="nav-link" data-bs-toggle="tab" :href="'#owner' + loadId" role="tab">
                  <ion-icon name="shield-checkmark-outline" role="img" class="md hydrated text-TEAL"></ion-icon>
                   صاحب بار
                </a>
              </li>
            </ul>

            <div class="tab-content mt-2">
              <div class="tab-pane fade show active" :id="'cargo' + loadId" role="tabpanel">
                <LoadInfo :loading="loading" :cargo="cargo" :owner="owner" />
                <AlertDriver :owner="owner" :loadId="loadId" />
              </div>

              <div class="tab-pane fade" :id="'owner' + loadId" role="tabpanel">
                <div class="text-center mb-2">
                  <div class="avatar">
                    <img src="assets/img/sample/avatar/Untitled-1.png" alt="avatar" class="imaged w64 rounded" />
                  </div>
                  <div class="my-1" v-if="owner?.ratingOwner != null && owner?.isAccepted == 1">
                    <star-rating :inline="true" :star-size="16" :read-only="true" :show-rating="false"
                      :rating="owner.ratingOwner" />
                  </div>
                  <div v-else-if="owner?.isAccepted == 1" class="my-1">
                    <star-rating :inline="true" :star-size="16" :read-only="true" :show-rating="false" :rating="5" />
                  </div>
                  <p class="text-TEAL owner-title" v-if="owner?.isAccepted == 1">تایید شده</p>
                  <hr class="m-0" />
                  <div class="text-left">
                    <div class="return-loads-text">
                      <button type="button" class="btn btn-link load-back p-0" data-bs-toggle="offcanvas"
                        @click="getDetailLoad" :data-bs-target="'#cargoDetail' + loadId">
                        مشاهده جزئیات بار
                        <ion-icon role="img" class="md hydrated" style="font-size: 15px; padding-top: 6px;"
                          name="chevron-forward-outline"></ion-icon>
                      </button>
                    </div>
                  </div>

                  <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" :id="'cargoDetail' + loadId">
                    <div class="offcanvas-header">
                      <h5 class="offcanvas-title">جزئیات بیشتر</h5>
                    </div>
                    <div class="offcanvas-body">
                      <Optional :loadId="loadId" :optional="optional" :cargo="cargo" />
                    </div>
                  </div>
                </div>

                <AlertDriver :owner="owner" :loadId="loadId" />
              </div>
            </div>
          </div>
        </div>

        <div class="footer-position px-3" id="footer">
          <div class="row my-2 g-1">
            <div class="col">
              <button v-if="loadingCall == 0" type="button" @click.prevent="callToOwner"
                class="btn background-ORANGE btn-block text-light btn-block" style="height: 3rem">
                <ion-icon name="call-outline" role="img" class="md hydrated"></ion-icon>
                تماس با صاحب بار
              </button>

              <button v-else class="btn background-ORANGE text-light btn-block" type="button" disabled>
                <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
                درحال بارگذاری ...
              </button>

              <button style="display: none" :id="'pardakht_' + loadId" type="button"
                class="btn background-ORANGE text-light btn-block" @click="offPardakht" data-bs-toggle="offcanvas"
                :data-bs-target="'#actionSheetContent_' + loadId">
                <ion-icon name="call-outline" role="img" class="md hydrated"></ion-icon>
                پرداخت
              </button>

              <Peyment :driver_id="idUser" :data="loadId" />
            </div>
          </div>

          <div class="row g-1">
            <div class="col" v-if="cargo.userType == 'owner' && statusAcceptCargo == 0 && accept == 0">
              <button class="btn btn-acceptCargo btn-block" type="button" :disabled="loadAccept == 1"
                @click.prevent="submitCargo()">
                <span v-if="loadAccept == 1" class="spinner-border spinner-border-sm me-05" role="status"
                  aria-hidden="true"></span>
                <ion-icon v-else name="checkmark-outline" role="img" class="md hydrated"></ion-icon>
                {{ loadAccept == 1 ? 'درحال بارگذاری ...' : 'پذیرش حمل بار' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import WithoutPrice from "@/components/fromToCity/WithoutPrice.vue";
import PaymentBox from "@/components/PaymentBox.vue";
import LoadInfo from "./components/LoadInfo.vue";
import AlertDriver from "@/components/AlertDriver.vue";
import StarRating from 'vue-star-rating';
import Swal from "sweetalert2";
import SideHeader from "@/components/SideHeader.vue";
import Routing from "./components/Routing.vue";
import Map from "@/components/Map.vue";
import Peyment from "@/components/Peyment.vue";
import router from "@/router";

export default {
  components: {
    WithoutPrice,
    PaymentBox,
    LoadInfo,
    AlertDriver,
    StarRating,
    SideHeader,
    Routing,
    Map,
    Peyment,
  },
  data() {
    return {
      loadId: this.$route.params.load,
      idUser: window.localStorage.getItem("idUser"),
      cargo: '',
      owner: '',
      loading: false,
      optional: [],
      path: '',
      loadAccept: 0,
      accept: 0,
      statusAcceptCargo: 0,
      loadingCall: 0,
      axiosConfig: {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      },
    };
  },
  methods: {
    getDetailLoad() {
      localStorage.setItem("openDetailLoad", this.loadId);
      if (history.pushState) {
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?openDetailLoad=1`;
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    getDetail() {
      this.loading = true;
      axios
        .get(`${delivery_methods.BASE_URL}api/driver/loadDetail/${this.loadId}`, this.axiosConfig)
        .then((res) => {
          this.loading = false;
          this.statusAcceptCargo = res.data.result;
          this.cargo = res.data.loadInfo;
          this.owner = res.data.owner;
          this.path = res.data.path;
          if (res.data.location_date === false) {
            this.getLocation();
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response?.status == 404) {

            Swal.fire({
              position: "center",
              icon: "warning",
              title: "بار مورد نظر حمل شده است.",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              window.location.href = "/";
            });

          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    offClose() {
      localStorage.setItem("offClose", this.loadId);
      if (history.pushState) {
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?offClose=1`;
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    callToOwner() {
      this.loadingCall = 1;
      axios
        .get(`${delivery_methods.BASE_URL}api/driver/checkDriverStatusForCalling/${this.cargo.mobileNumberForCoordination}/${this.loadId}/${window.localStorage.getItem("latitude")}/${window.localStorage.getItem("longitude")}`, this.axiosConfig)
        .then((res) => {
          if (res.data.result == 1 || res.data.result === true) {
            window.location.href = `tel:${this.cargo.mobileNumberForCoordination}`;
          } else if (res.data.result === false) {
            document.getElementById("pardakht_" + this.loadId).click();
          } else if (res.data.result === 2) {
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "آگهی منقضی شده است",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              router.push({ name: "home" });
            });

          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingCall = 0;
        });
    },
    submitCargo() {
      this.loadAccept = 1;
      axios
        .post("https://core.iran-tarabar.ir/api/driver/storeInquiryToLoad", {
          load_id: this.loadId,
          price: this.cargo.suggestedPrice ?? 0,
          latitude: window.localStorage.getItem("latitude"),
          longitude: window.localStorage.getItem("longitude"),
        }, this.axiosConfig)
        .then((res) => {
          if (res.data.result == 1) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "درخواست شما با موفقیت ثبت شد",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "شما به محدودیت تماس رسیده‌اید",
              showConfirmButton: false,
              timer: 2000,
            });
            document.getElementById("pardakht").click();
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadAccept = 0;
          this.accept = 1;
        });
    },
    offPardakht() {
      localStorage.setItem("offPardakht", this.loadId);
      if (history.pushState) {
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?offPardakht=1`;
        window.history.pushState({ path: newurl }, "", newurl);
      }
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      }
    },
    showPosition(position) {
      axios
        .get(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=fa`)
        .then((response) => {
          return axios.put(`https://core.iran-tarabar.ir/api/driver/updateLocation`, {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            city: response.data.city,
          }, this.axiosConfig);
        })
        .catch((error) => {
          console.warn("Location update failed", error);
        });
    },
    weathers() {
      axios
        .get("https://api.openweathermap.org/data/2.5/weather?lat=44.34&lon=10.99&appid=5f03d362072b012cff654e5b1a98e6b0")
        .then((response) => {
          console.log(response.data);
        })
        .catch(() => {
          this.weathers();
        });
    },
  },
  created() {
    this.getDetail();
  }
};
</script>

<style scoped>
.leaflet-container {
  z-index: 0 !important;
}

.appBottomMenu {
  display: none !important;
}

.weather-to {
  position: absolute;
  top: 3.8rem;
  background-color: #FFFFFFCC !important;
  border-radius: 6px;
  padding: 5px;
  margin: 0 3px;
}

.routing {
  position: absolute;
  top: 140px;
  left: 1rem;
  /* z-index: 999; */
}

.background-locate {
  background-color: #FFFFFFCC !important;
}

.text-locate {
  color: #068B80 !important;
}

.owner-title {
  margin-top: 10px;
  font-weight: 700;
}


.return-loads-wrapper {
  align-self: center;
  display: flex;
  font-size: 13px;
  padding: 4px 4px;
  float: left;
}


.return-loads-icon {
  /* aspect-ratio: 1; */
  object-fit: auto;
  object-position: center;
  width: 16px;
  margin: auto 0;
}

.return-loads-text {
  font-family: IRANSansXFaNum, sans-serif;
}

.space_detail {
  border-bottom: 1px dashed #e6e6e6;
  padding-bottom: 5px;
}

.footer-position {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
}

.load-back {
  /* float: left; */
  color: var(--Primery, #068b80);
  font-weight: 400
}

.border-gray {
  border-bottom: 1px solid #d9d9d9;
}

.btn-acceptCargo {
  color: #0EA47A !important;
  background: #fff;
  border: 1px solid;
}
</style>